import loadable from '@loadable/component'
import { useParams } from 'react-router'
import Route from 'components/App/Routes/TrackedRoute'
import LocaleAwareSwitch from 'components/App/Routes/LocaleAwareSwitch'
import CorporateEventLayout from './components/CorporateEventLayout'

const CorporateEventLandingPage = loadable(() => import(/* webpackChunkName: "CorporateEventLandingPage" */ './pages/CorporateEventLandingPage'))
const CorporateEventFAQPage = loadable(() => import(/* webpackChunkName: "CorporateEventFAQPage" */ './pages/CorporateEventFAQPage'))
const CorporateEventOtherActivitiesPage = loadable(() => import(/* webpackChunkName: "CorporateEventOtherActivitiesPage" */ './pages/CorporateEventOtherActivitiesPage'))
const CorporateEventFlightsPage = loadable(() => import(/* webpackChunkName: "CorporateEventFlightsPage" */ './pages/CorporateEventFlightsPage'))
const CorporateEventAccommodationPage = loadable(() => import(/* webpackChunkName: "CorporateEventAccommodationPage" */ './pages/CorporateEventAccommodationPage'))
const CorporateEventThingsToKnowPage = loadable(() => import(/* webpackChunkName: "CorporateEventThingsToKnowPage" */ './pages/CorporateEventThingsToKnowPage'))
const CorporateEventRegistrationPage = loadable(() => import(/* webpackChunkName: "CorporateEventRegistrationPage" */ './pages/CorporateEventRegistrationPage'))

function CorporateEventRoutes() {
  const { eventId, regionCode } = useParams<{ eventId: string; regionCode: string }>()

  return (
    <CorporateEventLayout eventId={eventId} regionCode={regionCode}>
      <LocaleAwareSwitch>
        <Route exact path="/:regionCode/corporate-events/:eventId" component={CorporateEventLandingPage} />
        <Route exact path="/:regionCode/corporate-events/:eventId/faq" component={CorporateEventFAQPage} />
        <Route exact path="/:regionCode/corporate-events/:eventId/other-activities" component={CorporateEventOtherActivitiesPage} />
        <Route exact path="/:regionCode/corporate-events/:eventId/flights" component={CorporateEventFlightsPage} />
        <Route exact path="/:regionCode/corporate-events/:eventId/accommodation" component={CorporateEventAccommodationPage} />
        <Route exact path="/:regionCode/corporate-events/:eventId/things-to-know" component={CorporateEventThingsToKnowPage} />
        <Route exact path="/:regionCode/corporate-events/:eventId/register" component={CorporateEventRegistrationPage} />
      </LocaleAwareSwitch>
    </CorporateEventLayout>
  )
}

export default CorporateEventRoutes
